module.exports = __webpack_public_path__ + "static/media/win-reward-A05.1be9a64f.png";